import { createContext, useContext } from "react";
import { Project } from "@/types/supabase.ext";
import { ProjectRole } from "@/hooks/useProjectRole";

export interface ProjectContextValue {
  projectId: string | undefined;
  project: Project | null;
  isLoadingProject: boolean;
  projectError: Error | null;
  refetchProject: () => void;
  // Permission values
  userRole: ProjectRole;
  isLoadingRole: boolean;
  canView: boolean;
  canEdit: boolean;
  canManage: boolean;
  canDelete: boolean;
}

export const ProjectContext = createContext<ProjectContextValue | undefined>(undefined);

export function useProjectContext(): ProjectContextValue {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error("useProjectContext must be used within ProjectLayout");
  }
  return context;
}
